/* Nelvo — storefront JS (vanilla, no deps) */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const R = window.NELVO.routes;
  const LOC = window.NELVO.locale || 'sv', CUR = window.NELVO.currency || 'SEK';
  /* testi da locales/*.json (nv.js.*): T('chiave', { n: 2 }) */
  const T = (k, v = {}) => String((window.NELVO.t || {})[k] ?? k).replace(/\{(\w+)\}/g, (_, x) => v[x] ?? '');
  const ROOT = (R.root || '/').replace(/\/$/, '');
  const kr0 = new Intl.NumberFormat(LOC, { style: 'currency', currency: CUR, maximumFractionDigits: 0, minimumFractionDigits: 0 });
  const kr2 = new Intl.NumberFormat(LOC, { style: 'currency', currency: CUR });
  const money = (c) => ((c || 0) % 100 === 0 ? kr0 : kr2).format((c || 0) / 100);
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (m) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]));
  const sizeUrl = (url, w) => {
    if (!url) return '';
    try { const u = new URL(url, location.origin); u.searchParams.set('width', w); return u.toString(); } catch { return url; }
  };
  const ICON = {
    gift: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="8" width="18" height="4"/><path d="M5 12v9h14v-9M12 8v13M12 8S10.5 3.5 8 4.2 8.2 8 12 8zm0 0s1.5-4.5 4-3.8S15.8 8 12 8z"/></svg>',
    trash: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3"/></svg>',
    tag: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"><path d="M3 12V3h9l9 9-9 9z"/><circle cx="7.5" cy="7.5" r="1.4" fill="currentColor"/></svg>',
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>',
  };

  /* ---------------- toast ---------------- */
  let toastT;
  const toast = (msg) => {
    const t = $('[data-toast]'); if (!t) return;
    t.textContent = msg; t.classList.add('on');
    clearTimeout(toastT); toastT = setTimeout(() => t.classList.remove('on'), 2600);
  };

  /* ---------------- drawers ---------------- */
  const overlay = $('[data-overlay]');
  let openDrawer = null;
  const showOverlay = (on) => {
    if (!overlay) return;
    if (on) { overlay.hidden = false; requestAnimationFrame(() => overlay.classList.add('is-on')); }
    else { overlay.classList.remove('is-on'); setTimeout(() => { if (!overlay.classList.contains('is-on')) overlay.hidden = true; }, 300); }
  };
  const open = (name) => {
    const d = $(`[data-drawer="${name}"]`); if (!d) return;
    if (openDrawer && openDrawer !== d) close(true);
    closeSearch();
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('lock'); showOverlay(true); openDrawer = d;
    setTimeout(() => $('[data-close]', d)?.focus({ preventScroll: true }), 50);
  };
  const close = (keepOverlay) => {
    if (!openDrawer) return;
    openDrawer.classList.remove('is-open'); openDrawer.setAttribute('aria-hidden', 'true'); openDrawer = null;
    if (!keepOverlay) { document.body.classList.remove('lock'); showOverlay(false); }
  };
  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-open]');
    if (o) { e.preventDefault(); const n = o.dataset.open; if (n === 'cart') Cart.refresh(); open(n); return; }
    if (e.target.closest('[data-close]') || e.target === overlay) { close(); closeSearch(); }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { close(); closeSearch(); } });

  /* ---------------- header ---------------- */
  const hdr = $('[data-hdr]');
  if (hdr) {
    const onScroll = () => hdr.classList.toggle('is-stuck', window.scrollY > 8);
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  /* ---------------- search ---------------- */
  const sPop = $('[data-search-pop]');
  function closeSearch() { if (sPop?.classList.contains('is-open')) { sPop.classList.remove('is-open'); sPop.setAttribute('aria-hidden', 'true'); if (!openDrawer) { showOverlay(false); document.body.classList.remove('lock'); } } }
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-open-search]')) {
      e.preventDefault(); close(true); sPop.classList.add('is-open'); sPop.setAttribute('aria-hidden', 'false'); showOverlay(true);
      setTimeout(() => $('[data-search-input]', sPop)?.focus(), 80);
    }
  });
  if (sPop) {
    const input = $('[data-search-input]', sPop), res = $('[data-search-res]', sPop);
    let st, ctrl;
    input.addEventListener('input', () => {
      clearTimeout(st);
      const q = input.value.trim();
      if (q.length < 2) { res.innerHTML = ''; return; }
      st = setTimeout(async () => {
        ctrl?.abort(); ctrl = new AbortController();
        try {
          const r = await fetch(`${R.search}.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`, { signal: ctrl.signal });
          const j = await r.json(); const ps = j.resources?.results?.products || [];
          res.innerHTML = ps.length ? ps.map((p) => `<a class="sres" href="${esc(p.url)}"><img src="${esc(sizeUrl(p.featured_image?.url || p.image, 160))}" alt="" loading="lazy"><b>${esc(p.title)}</b><span>${money(Math.round(parseFloat(p.price) * 100))}</span></a>`).join('')
            : `<p class="t-mute sres__none">${esc(T('no_hits', { q }))}</p>`;
        } catch {}
      }, 180);
    });
  }


  /* ---------------- slideshow ----------------
     Slide intere (niente card tagliate a metà): frecce, un pallino per pagina, scorrimento a pagine.
     data-autoplay="N" → avanza ogni N secondi solo se visibile; si ferma al tocco/hover e riparte dopo 8 s. */
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const Slider = (root) => {
    if (root.__sl) { root.__sl.refresh(); return root.__sl; }
    const track = $('[data-track]', root), nav = $('[data-slider-nav]', root), dots = $('[data-dots]', root);
    let per = 1, step = 1, pages = 1, timer = null, idleT = null, visible = false;
    const items = () => Array.from(track.children).filter((c) => !c.hidden);
    const measure = () => {
      const it = items(); if (!it.length) { pages = 0; return; }
      const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      step = it[0].getBoundingClientRect().width + gap;
      per = Math.max(1, Math.round((track.clientWidth + gap) / step));
      pages = Math.ceil(it.length / per);
    };
    const cur = () => Math.min(pages - 1, Math.round(track.scrollLeft / (step * per)));
    const go = (i, smooth = true) => { const n = (i + pages) % pages; track.scrollTo({ left: n * per * step, behavior: smooth ? 'smooth' : 'auto' }); };
    const paint = () => {
      const c = cur();
      if (pages > 8) { const i = $('.slider__prog i', dots), n = $('.slider__count', dots); if (i) i.style.width = `${((c + 1) / pages) * 100}%`; if (n) n.textContent = `${c + 1} / ${pages}`; return; }
      $$('button', dots).forEach((b, k) => { b.classList.toggle('on', k === c); b.setAttribute('aria-current', k === c); });
    };
    const refresh = () => {
      measure();
      if (nav) nav.hidden = pages <= 1;
      /* tante pagine (es. 50 recensioni): barra di avanzamento + contatore al posto dei pallini, che non starebbero nello schermo */
      dots.innerHTML = pages > 8 ? '<span class="slider__prog" aria-hidden="true"><i></i></span><span class="slider__count"></span>'
        : pages > 1 ? Array.from({ length: pages }, (_, k) => `<button type="button" aria-label="${esc(T('page', { n: k + 1 }))}"></button>`).join('') : '';
      paint();
    };
    const stop = () => { clearInterval(timer); timer = null; };
    const play = () => {
      const sec = +root.dataset.autoplay; if (!sec || reduced || pages <= 1 || !visible || document.hidden) return;
      stop(); timer = setInterval(() => go(cur() + 1), sec * 1000);
    };
    const pause = () => { stop(); clearTimeout(idleT); idleT = setTimeout(play, 8000); };
    $('[data-prev]', root)?.addEventListener('click', () => { pause(); go(cur() - 1); });
    $('[data-next]', root)?.addEventListener('click', () => { pause(); go(cur() + 1); });
    dots.addEventListener('click', (e) => { const b = e.target.closest('button'); if (!b) return; pause(); go($$('button', dots).indexOf(b)); });
    track.addEventListener('scroll', () => requestAnimationFrame(paint), { passive: true });
    ['pointerenter', 'touchstart', 'focusin'].forEach((ev) => root.addEventListener(ev, pause, { passive: true }));
    if ('IntersectionObserver' in window) new IntersectionObserver(([en]) => { visible = en.isIntersecting; visible ? play() : stop(); }, { threshold: .4 }).observe(root);
    document.addEventListener('visibilitychange', () => (document.hidden ? stop() : play()));
    let rz; window.addEventListener('resize', () => { clearTimeout(rz); rz = setTimeout(() => { refresh(); go(cur(), false); }, 150); });
    refresh();
    return (root.__sl = { refresh, go });
  };
  const initSliders = (scope = document) => $$('[data-slider]', scope).forEach((el) => Slider(el));
  initSliders();

  /* ---------------- leveransdatum ---------------- */
  const eta = () => {
    const add = (n) => { const d = new Date(); let k = 0; while (k < n) { d.setDate(d.getDate() + 1); const w = d.getDay(); if (w !== 0 && w !== 6) k++; } return d; };
    const f = new Intl.DateTimeFormat(LOC, { weekday: 'short', day: 'numeric', month: 'short' });
    const fm = (d) => (LOC === 'sv' ? f.format(d).replace('.', '') : f.format(d));
    const a = fm(add(3)), b = fm(add(5));
    $$('[data-eta]').forEach((el) => (el.textContent = `${a} – ${b}`));
  };
  eta();

  /* ---------------- cart ---------------- */
  const Cart = (() => {
    const d = $('[data-drawer="cart"]');
    let cart = null, busy = false, upsellPool = null;
    /* Tagada precarica la sessione di checkout per token carrello e la rifà 250 ms dopo ogni modifica:
       la si cancella PRIMA di ogni modifica, così un clic durante il ricalcolo crea una sessione nuova. */
    const dropPreload = () => { try { Object.keys(localStorage).forEach((k) => { if (k.indexOf('tgd_preload_') === 0) localStorage.removeItem(k); }); } catch {} };
    const post = (url, body) => (dropPreload(), fetch)(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(async (r) => { const j = await r.json(); if (!r.ok) throw new Error(j.description || j.message || 'Fel'); return j; });

    /* Omaggio DormiPuro® (snippets/gift-config.liquid): riga a 0 con quantità = pezzi DormiPuro, fuori dal conteggio pezzi */
    const GIFT = window.NELVO.gift || null;
    const isGift = (it) => !!GIFT && it.variant_id === GIFT.v;
    const pieces = (c) => c.items.reduce((a, it) => a + (isGift(it) ? 0 : it.quantity), 0);
    /* tipi con prezzo pacchetto proprio: esclusi dai −20/−30 % (collezione rabatt-paket) → non contano per la barra sconti */
    /* per handle: in cart.js product_type arriva TRADOTTO nella lingua del sito */
    const NO_DISC = ['moka-scooter', 'dormipuro-2-i-1-tacke', 'hollyglow-julprojektor', 'retrox-retrokonsol', 'toeletta-trucco', 'playretro', 'comodino-cassetto-segreto'];
    const discPieces = (c) => c.items.reduce((a, it) => a + (isGift(it) || NO_DISC.includes(it.handle) ? 0 : it.quantity), 0);
    const getCart = async () => (await fetch(R.cart, { headers: { Accept: 'application/json' } })).json();
    const syncGift = async (c) => {
      if (!GIFT || !c) return c;
      try {
        const want = c.items.reduce((a, it) => a + (GIFT.for.includes(it.product_id) ? it.quantity : 0), 0);
        const g = c.items.find(isGift);
        if (want === (g ? g.quantity : 0)) return c;
        if (g) return await post(R.cartChange, { id: g.key, quantity: want });
        await post(R.cartAdd, { items: [{ id: GIFT.v, quantity: want }] });
        return await getCart();
      } catch { return c; }
    };

    const setCount = (n) => $$('[data-cart-count]').forEach((el) => {
      const prev = el.dataset.count; el.dataset.count = n; el.textContent = n > 0 ? n : '';
      if (String(prev) !== String(n) && n > 0) { el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump'); }
    });

    const bar = (n) => {
      const msg = $('[data-bar-msg]', d), fill = $('[data-progress-fill]', d), prog = $('[data-progress]', d);
      if (!msg) return;
      let html;
      if (n <= 0) html = `${ICON.tag}<span>${T('bar0_html')}</span>`;
      else if (n === 1) html = `${ICON.tag}<span>${T('bar1_html')}</span>`;
      else if (n === 2) html = `<span class="t-acc">${ICON.check}</span><span>${T('bar2_html')}</span>`;
      else html = `<span class="t-acc">${ICON.check}</span><span>${T('bar3_html')}</span>`;
      msg.innerHTML = html;
      fill.style.width = `${Math.min(n, 3) / 3 * 100}%`;
      prog.classList.toggle('is-max', n >= 3);
      $$('[data-step]', d).forEach((s) => s.classList.toggle('on', n >= +s.dataset.step));
    };

    const lineHTML = (it) => {
      if (isGift(it)) return `<div class="line line--gift" data-key="${esc(it.key)}">
        <span class="line__img"><img src="${esc(sizeUrl(it.image, 240))}" alt="" loading="lazy"></span>
        <div>
          <div class="line__top"><div><span class="line__title">${esc(it.product_title.split(' – ')[0])}</span><div class="line__gift">${ICON.gift}${esc(T('gift'))} · ${it.quantity} ×</div></div></div>
          <div class="line__bot"><span></span><div class="line__price">${GIFT.value ? `<s>${esc(GIFT.value)}</s>` : ''}<b>${esc(T('gift_free'))}</b></div></div>
        </div>
      </div>`;
      const after = Math.min(it.final_line_price, it.original_line_price - (it.line_level_total_discount || 0));
      const disc = it.original_line_price > after;
      const vt = !it.product_has_only_default_variant && it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
      /* proprietà della riga (personalizzazione, es. Nome/Numero GoalGlow); quelle con "_" iniziale restano nascoste */
      const pp = Object.entries(it.properties || {}).filter(([k, v]) => v != null && v !== '' && k[0] !== '_');
      return `<div class="line" data-key="${esc(it.key)}">
        <a class="line__img" href="${esc(it.url)}"><img src="${esc(sizeUrl(it.image, 240))}" alt="" loading="lazy"></a>
        <div>
          <div class="line__top">
            <div><a class="line__title" href="${esc(it.url)}">${esc(it.product_title)}</a>${vt ? `<div class="line__var">${esc(vt)}</div>` : ''}${pp.length ? `<div class="line__props">${pp.map(([k, v]) => `<span>${esc(k)}: <b>${esc(v)}</b></span>`).join('')}</div>` : ''}</div>
            <button class="line__rm" type="button" data-rm aria-label="${esc(T('remove'))}">${ICON.trash}</button>
          </div>
          <div class="line__bot">
            <div class="qty"><button type="button" data-q="-1" aria-label="${esc(T('decrease'))}">−</button><span>${it.quantity}</span><button type="button" data-q="1" aria-label="${esc(T('increase'))}">+</button></div>
            <div class="line__price">${disc ? `<s>${money(it.original_line_price)}</s>` : ''}${money(after)}</div>
          </div>
        </div>
      </div>`;
    };

    /* Shopify TRONCA i centesimi degli sconti % (169,98 × 20 % = 33,996 → 33,99), il checkout Tagada arrotonda (34,00):
       nel carrello si mostra il totale arrotondato come al checkout. Solo correzioni da 1 centesimo per sconto. */
    const totale = (c) => {
      const apps = {};
      c.items.forEach((it) => (it.line_level_discount_allocations || []).forEach((a) => {
        const da = a.discount_application || {}; if (da.value_type !== 'percentage' || da.allocation_method !== 'across') return;
        const k = da.key || da.title; (apps[k] ||= { pct: parseFloat(da.value), base: 0, got: 0 });
        apps[k].base += it.original_line_price; apps[k].got += a.amount;
      }));
      let adj = 0; Object.values(apps).forEach((a) => { const d = a.got - Math.round((a.base * a.pct) / 100); if (Math.abs(d) <= 1) adj += d; });
      return c.total_price + adj;
    };
    const render = (c) => {
      cart = c; if (!d) return;
      const tot = totale(c);
      const n = pieces(c);
      setCount(n);
      $('[data-cart-n]', d).textContent = n ? `(${n})` : '';
      $('[data-cart-items]', d).innerHTML = [...c.items.filter((it) => !isGift(it)), ...c.items.filter(isGift)].map(lineHTML).join('');
      $('[data-cart-empty]', d).hidden = n > 0;
      $('[data-cart-foot]', d).hidden = n === 0;
      const nd = discPieces(c);
      $('[data-cart-bar]', d).hidden = n === 0 || nd === 0; /* solo prodotti esclusi (es. Moka): niente promessa −20 % */
      bar(nd);
      const sub = c.items.reduce((a, it) => a + it.original_line_price, 0);
      const save = sub - tot;
      $('[data-sum-sub]', d).textContent = money(sub);
      $('[data-sum-save-row]', d).hidden = save <= 0;
      if (save > 0) {
        const pct = Math.round((save / sub) * 100); // reale (i pacchetti a prezzo fisso, es. Moka, non sono 20/30)
        $('[data-sum-save-label]', d).textContent = n >= 2 && pct ? T('bundle_pct', { pct }) : T('discount');
        $('[data-sum-save]', d).textContent = `−${money(save)}`;
      }
      $('[data-sum-tot]', d).textContent = money(tot);
      $('[data-checkout-tot]', d).textContent = `· ${money(tot)}`;
      if (d.classList.contains('is-open')) renderUpsell();
    };

    const loadPool = async () => {
      if (upsellPool) return upsellPool;
      const h = window.NELVO.upsell || 'bastsaljare';
      try {
        const r = await fetch(`${ROOT}/collections/${h}/products.json?limit=24`);
        upsellPool = (await r.json()).products || [];
      } catch { upsellPool = []; }
      return upsellPool;
    };
    const renderUpsell = async () => {
      const box = $('[data-upsell]', d); if (!box || !cart) return;
      if (window.NELVO.upsellOff || !pieces(cart)) { box.hidden = true; return; }
      const pool = await loadPool();
      const inCart = new Set(cart.items.map((i) => i.product_id));
      const types = new Set(cart.items.map((i) => i.product_type));
      /* prima i prodotti più economici di categorie diverse: il secondo pezzo che fa scattare lo sconto */
      const list = pool.filter((p) => !inCart.has(p.id) && p.variants.some((v) => v.available))
        .sort((a, b) => ((types.has(a.product_type) ? 1 : 0) - (types.has(b.product_type) ? 1 : 0)) || (parseFloat(a.variants[0].price) - parseFloat(b.variants[0].price))).slice(0, 6);
      if (!list.length) { box.hidden = true; return; }
      const n = discPieces(cart);
      $('[data-upsell-hint]', d).textContent = n === 0 ? '' : n === 1 ? T('ups_1') : n === 2 ? T('ups_2') : T('ups_3');
      $('[data-upsell-list]', d).innerHTML = list.map((p) => {
        const vs = p.variants.filter((v) => v.available);
        return `<div class="ups__card" data-ups>
          <a href="${ROOT}/products/${esc(p.handle)}" class="ups__img"><img src="${esc(sizeUrl(p.images[0]?.src, 200))}" alt="" loading="lazy"></a>
          <div class="ups__b">
            <a href="${ROOT}/products/${esc(p.handle)}" class="ups__t">${esc(p.title)}</a>
            <div class="ups__p">${money(Math.round(parseFloat(vs[0].price) * 100))}</div>
            ${vs.length > 1 ? `<select aria-label="${esc(T('color'))}">${vs.map((v) => `<option value="${v.id}">${esc(v.title)}</option>`).join('')}</select>` : `<input type="hidden" value="${vs[0].id}">`}
            <button type="button" class="btn btn--sm btn--ghost ups__add" data-ups-add>${esc(T('add'))}<span class="spin"></span></button>
          </div>
        </div>`;
      }).join('');
      box.hidden = false;
      initSliders(box);
    };

    const refresh = async () => { try { render(await syncGift(await getCart())); } catch {} };

    const add = async (items, btn) => {
      if (busy) return; busy = true; btn?.classList.add('is-loading');
      try {
        const gq = GIFT ? items.reduce((a, it) => a + ((GIFT.vids || []).includes(+it.id) ? +it.quantity || 1 : 0), 0) : 0;
        await post(R.cartAdd, { items: gq ? [...items, { id: GIFT.v, quantity: gq }] : items });
        /* Tagada (precarica il checkout) rifiuta il carrello se la nota è null: la si rende stringa vuota una volta */
        if (!cart || cart.note === null || cart.note === undefined) { try { const c = await (await fetch(R.cart, { headers: { Accept: 'application/json' } })).json(); if (c.note === null) await post('/cart/update.js', { note: '' }); } catch {} }
        await refresh(); open('cart'); renderUpsell();
        try { /* TikTok AddToCart: righe aggiunte, prezzo dal carrello aggiornato */
          if (window.ttq && cart) {
            const lines = items.map((it) => { const l = cart.items.find((x) => x.variant_id === +it.id); return l ? { content_id: String(l.variant_id), content_type: 'product', content_name: l.product_title, quantity: it.quantity, price: l.final_price / 100 } : null; }).filter(Boolean);
            if (lines.length) window.ttq.track('AddToCart', { contents: lines, value: lines.reduce((a, l) => a + l.price * l.quantity, 0), currency: cart.currency });
          }
        } catch {}
      } catch (err) { toast(/slut|sold out|ausverkauft|épuisé|esaurit|agotad|uitverkocht/i.test(err.message) ? T('sold_out') : T('error')); }
      finally { busy = false; btn?.classList.remove('is-loading'); }
    };

    const change = async (key, quantity) => {
      const line = $(`.line[data-key="${CSS.escape(key)}"]`, d); line?.classList.add('is-busy');
      try {
        const it = cart && cart.items.find((x) => x.key === key), g = cart && cart.items.find(isGift);
        if (GIFT && it && g && GIFT.for.includes(it.product_id)) {
          const want = cart.items.reduce((a, x) => a + (GIFT.for.includes(x.product_id) ? (x.key === key ? quantity : x.quantity) : 0), 0);
          render(await syncGift(await post(R.cartChange.replace(/change\.js$/, 'update.js'), { updates: { [key]: quantity, [g.key]: want } })));
        } else render(await syncGift(await post(R.cartChange, { id: key, quantity })));
      }
      catch { toast(T('no_stock')); line?.classList.remove('is-busy'); }
    };

    d?.addEventListener('click', (e) => {
      const line = e.target.closest('.line');
      if (line && e.target.closest('[data-rm]')) return change(line.dataset.key, 0);
      const q = e.target.closest('[data-q]');
      if (line && q) { const it = cart.items.find((i) => i.key === line.dataset.key); return change(line.dataset.key, Math.max(0, it.quantity + +q.dataset.q)); }
      const ub = e.target.closest('[data-ups-add]');
      if (ub) { const card = ub.closest('[data-ups]'); add([{ id: +$('select, input', card).value, quantity: 1 }], ub); }
    });
    $$('[data-checkout-form]').forEach((f) => f.addEventListener('submit', () => $('[data-checkout]', f)?.classList.add('is-loading')));
    window.addEventListener('pageshow', (e) => { if (e.persisted) { $$('[data-checkout]').forEach((b) => b.classList.remove('is-loading')); refresh(); } });
    /* omaggio: allinea anche i carrelli nati prima o cambiati dalla pagina /cart (solo se il carrello non è vuoto) */
    if (GIFT && +($('[data-cart-count]') || {}).dataset?.count > 0) refresh();
    return { add, refresh };
  })();

  /* ---------------- product page ---------------- */
  const pdp = $('[data-pdp]');
  if (pdp) {
    const P = JSON.parse($('[data-product-json]', pdp).textContent);
    const multiColor = P.colors.length > 1;
    const SZ = P.sizeLabel || T('size'); // etichetta taglia: nome opzione se l'unica opzione non è un colore (es. Lunghezza)
    const hasSize = (P.sizes || []).length > 1; // 2ª opzione (taglia) con prezzi per variante: tendina taglia per pezzo + prezzi dal vivo
    const st = { c: null, s: null, tier: 1 };
    const urlV = new URLSearchParams(location.search).get('variant');
    const startV = P.variants.find((v) => String(v.id) === urlV) || P.variants.find((v) => v.a) || P.variants[0];
    st.c = startV.c; st.s = startV.s;
    const units = []; // [{c, s, touchedC, touchedS, nm, no}]
    /* personalizzazione per pezzo (pdp-core: <script data-perso>, solo prodotti con custom.personalize, es. GoalGlow Nome + Numero) */
    const PZ = (() => { try { const x = $('[data-perso]', pdp); return x ? JSON.parse(x.textContent) : null; } catch { return null; } })();
    const PZT = (PZ && PZ.t) || {}, PZN = ((PZ && PZ.fields) || []).find((f) => f.k === 'name') || { max: 12 }, PZD = ((PZ && PZ.fields) || []).find((f) => f.k === 'num') || { min: 0, max: 99 };
    const findV = (c, s) => P.variants.find((v) => v.c === c && (!hasSize || v.s === (s ?? st.s)));
    const track = $('[data-gal-track]', pdp), dots = $('[data-gal-dots]', pdp), thumbs = $('[data-gal-thumbs]', pdp);
    /* tante foto: contatore «1 / 27» al posto dei pallini */
    const cnt = $('[data-gal-cnt]', pdp);
    const count = () => { if (!cnt) return; const n = $$('button', dots).length, i = Math.round(track.scrollLeft / track.clientWidth); pdp.classList.toggle('gal--many', n > 7); cnt.textContent = `${Math.min(i + 1, n)} / ${n}`; };

    const hyd = (sl) => { const vd = sl && $('video[data-poster]', sl); if (vd) { vd.poster = vd.dataset.poster; vd.removeAttribute('data-poster'); } const im = sl && $('img[data-src]', sl); if (!im) return; im.loading = 'eager'; if (im.dataset.srcset) { im.srcset = im.dataset.srcset; im.removeAttribute('data-srcset'); } im.src = im.dataset.src; im.removeAttribute('data-src'); };
    const hydAll = () => $$('.gal__slide', track).forEach(hyd);
    // indirizzo vero per le miniature: currentSrc può essere ancora il segnaposto 1×1 mentre la foto sta caricando
    /* miniature: immagini assegnate solo a pagina caricata (prima la banda va a foto principale e pixel) */
    const thLoad = () => { const go = () => $$('img[data-thsrc]', pdp).forEach((i) => { i.src = i.dataset.thsrc; i.removeAttribute('data-thsrc'); }); if (document.readyState === 'complete') go(); else window.addEventListener('load', go, { once: true }); };
    const thSrc = (im) => im?.dataset.src || (im?.currentSrc && !im.currentSrc.startsWith('data:') ? im.currentSrc : null) || (im?.getAttribute('src') || '').replace(/^data:.*/, '') || im?.src;
    /* video in galleria: caricati e avviati solo quando la slide è visibile, in pausa quando esce */
    const vids = $$('video[data-vsrc]', track);
    if (vids.length && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver((es) => es.forEach((e) => { const v = e.target; if (e.isIntersecting) { if (v.dataset.poster) { v.poster = v.dataset.poster; v.removeAttribute('data-poster'); } if (!v.src) v.src = v.dataset.vsrc; v.play().catch(() => {}); } else v.pause(); }), { root: track, threshold: 0.6 });
      vids.forEach((v) => io.observe(v));
    }
    const galAll = pdp.hasAttribute('data-gal-all'); // tag galleri-alla: tutte le foto nel carosello, il colore scorre alla sua
    const slideIdx = (c) => $$('.gal__slide', track).findIndex((s) => s.dataset.color === c);
    const gallery = () => {
      const slides = $$('.gal__slide', track);
      if (galAll) {
        if (!thumbs.childElementCount) { pdp.classList.toggle('gal-one', slides.length < 2); thumbs.innerHTML = slides.length > 1 ? slides.map((sl, i) => { const im = $('img', sl); return `<button type="button" class="gal__th${i === 0 ? ' on' : ''}" data-th="${i}" aria-label="${esc(T('image', { n: i + 1 }))}"><img data-thsrc="${esc(sizeUrl(thSrc(im), 200))}" alt="" loading="lazy"></button>`; }).join('') : ''; thLoad(); }
        const i = slideIdx(st.c);
        hyd(slides[Math.max(i, 0)]);
        if (i >= 0 && Math.round(track.scrollLeft / track.clientWidth) !== i) track.scrollTo({ left: i * track.clientWidth, behavior: thumbs.dataset.ready ? 'smooth' : 'auto' });
        if (!dots.childElementCount && slides.length > 1) dots.innerHTML = slides.map((_, k) => `<button type="button" aria-label="${esc(T('image', { n: k + 1 }))}"${k === Math.max(i, 0) ? ' class="on"' : ''}></button>`).join('');
        thumbs.dataset.ready = 1; count();
        return;
      }
      const show = multiColor ? slides.filter((s) => s.dataset.color === st.c) : slides.filter((s) => s.dataset.color);
      const shared = slides.filter((s) => !s.dataset.color);
      const vis = new Set([...show, ...shared]);
      if (vis.size === 0) slides.forEach((s) => vis.add(s));
      slides.forEach((s) => (s.hidden = !vis.has(s)));
      show.forEach((s) => track.appendChild(s)); shared.forEach((s) => track.appendChild(s));
      slides.filter((s) => s.hidden).forEach((s) => track.appendChild(s));
      const visible = $$('.gal__slide', track).filter((s) => !s.hidden); // ordine reale del DOM dopo il riordino
      hyd(visible[0]); if (document.readyState === 'complete') hyd(visible[1]); /* prima del load la 2ª la fa afterLoad (+3 s): banda a foto principale e pixel */
      track.scrollTo({ left: 0 });
      dots.innerHTML = visible.length > 1 ? visible.map((_, i) => `<button type="button" aria-label="${esc(T('image', { n: i + 1 }))}"${i === 0 ? ' class="on"' : ''}></button>`).join('') : '';
      pdp.classList.toggle('gal-one', visible.length < 2);
      count();
      thumbs.innerHTML = visible.length > 1 ? visible.map((sl, i) => { const im = $('img', sl); return `<button type="button" class="gal__th${i === 0 ? ' on' : ''}" data-th="${i}" aria-label="${esc(T('image', { n: i + 1 }))}"><img data-thsrc="${esc(sizeUrl(thSrc(im), 200))}" alt="" loading="lazy"></button>`; }).join('') : ''; thLoad();
    };
    let galT;
    /* le altre foto: la successiva a pagina caricata, tutte al primo tocco sul carosello */
    /* 19-ott: al primo tocco PRIMA la foto successiva (da sola, arriva subito), le altre 350 ms dopo: prima partivano tutte insieme e la 2ª arrivava tardi */
    const hydNext = () => { const v = $$('.gal__slide', track).filter((x) => !x.hidden); const i = Math.round(track.scrollLeft / track.clientWidth); hyd(v[i + 1]); hyd(v[i]); setTimeout(hydAll, 350); };
    ['pointerdown', 'touchstart', 'scroll'].forEach((ev) => track.addEventListener(ev, hydNext, { once: true, passive: true }));
    thumbs.addEventListener('pointerdown', hydAll, { once: true, passive: true });
    const nextHyd = () => { const v = $$('.gal__slide', track).filter((x) => !x.hidden); hyd(v[1]); };
    const warmColors = () => { const seen = new Set(); $$('.gal__slide', track).forEach((s) => { const c = s.dataset.color; if (c && !seen.has(c)) { seen.add(c); hyd(s); } }); };
    const idle = (fn) => ('requestIdleCallback' in window ? requestIdleCallback(fn, { timeout: 2500 }) : setTimeout(fn, 1200));
    const afterLoad = () => setTimeout(() => { nextHyd(); idle(warmColors); }, 700); /* 19-ott: 3 s → 0,7 s dopo il load (il pixel TikTok a quel punto è già partito): la 2ª foto è pronta prima che il cliente scorra */
    if (document.readyState === 'complete') afterLoad(); else addEventListener('load', afterLoad, { once: true });
    track.addEventListener('scroll', () => {
      const i = Math.round(track.scrollLeft / track.clientWidth);
      if (galAll) { clearTimeout(galT); galT = setTimeout(() => { const c = $$('.gal__slide', track)[Math.round(track.scrollLeft / track.clientWidth)]?.dataset.color; if (c && c !== st.c && P.colors.includes(c)) setColor(c); }, 160); }
      $$('button', dots).forEach((b, k) => b.classList.toggle('on', k === i));
      count();
      $$('.gal__th', thumbs).forEach((b, k) => { b.classList.toggle('on', k === i); if (k === i) { const l = b.offsetLeft - (thumbs.clientWidth - b.clientWidth) / 2; thumbs.scrollTo({ left: l, behavior: 'smooth' }); } });
    }, { passive: true });
    thumbs.addEventListener('click', (e) => { const b = e.target.closest('[data-th]'); if (b) track.scrollTo({ left: +b.dataset.th * track.clientWidth, behavior: 'smooth' }); });
    dots.addEventListener('click', (e) => { const b = e.target.closest('button'); if (!b) return; const i = $$('button', dots).indexOf(b); track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); });


    const FACT = (n) => (n === 3 ? 0.7 : n === 2 ? 0.8 : 1);
    const fullPrice = (n) => units.slice(0, n).reduce((a, u) => a + (findV(u.c, u.s)?.p ?? P.price), 0);
    const tierPrice = (n) => (hasSize && !P.fixed ? Math.round(fullPrice(n) * FACT(n)) : (P.bundle && P.bundle[n - 1]) || Math.round(P.price * n * FACT(n)));
    /* prezzo di listino (barrato): compare_at della variante se c'è, sennò il prezzo */
    const listOf = (v) => (v && v.cp > v.p ? v.cp : v?.p ?? P.price);
    const listPrice = (n) => units.slice(0, n).reduce((a, u) => a + listOf(findV(u.c, u.s)), 0);
    const tierPrices = () => { // solo prodotti con taglia: totali, barrati e prezzo/pezzo seguono le taglie scelte
      if (!hasSize) return;
      [1, 2, 3].forEach((n) => {
        const t = $(`[data-tier="${n}"]`, pdp); if (!t) return;
        if (n > 1) ensureUnitsFor(n);
        const full = listPrice(n), tot = tierPrice(n);
        const pill = $('.save-pill', t); if (pill && full > tot) pill.textContent = `−${Math.round(((full - tot) / full) * 100)} %`;
        const b = $('[data-tp]', t); if (b) b.innerHTML = moneyHtml(tot);
        const c = $('[data-tc]', t); if (c) c.textContent = money(full);
        const u = $('[data-tu]', t); if (u) u.innerHTML = T('per_unit_html', { unit: money(Math.round(tot / n)), save: money(full - tot) });
      });
      const v1 = findV(units[0]?.c ?? st.c, units[0]?.s ?? st.s);
      const now = $('[data-price-now]', pdp); if (now) now.innerHTML = moneyHtml(v1?.p ?? P.price);
      const was = $('[data-price-was]', pdp), sp = $('[data-sale-pill]', pdp);
      if (was && v1) { const on = v1.cp > v1.p; was.hidden = !on; if (sp) sp.hidden = !on; if (on) { was.textContent = money(v1.cp); if (sp) sp.textContent = `−${Math.floor(((v1.cp - v1.p) / v1.cp) * 100 + 0.01)} %`; } }
    };
    const moneyHtml = (c) => { const t = money(c), m = t.match(/^(.*?)([,.]\d{2})(\D*)$/); return m && !/^[,.]00$/.test(m[2]) ? `${esc(m[1])}<small>${esc(m[2])}</small>${esc(m[3])}` : esc(t.replace(/[,.]00(?=\D*$)/, '')); };
    const label = () => {
      tierPrices();
      $('[data-atc-label]', pdp).textContent = T('atc', { price: money(tierPrice(st.tier)) });
      const sp = $('[data-sticky-p]', pdp); if (sp) sp.textContent = `${P.pack > 1 ? `${st.tier}+${st.tier} · ` : st.tier > 1 ? `${T('pcs', { n: st.tier })} · ` : ''}${money(tierPrice(st.tier))} · ${T('free_ship')}`;
    };
    const unitsBox = () => $(`[data-tier="${st.tier}"] [data-units]`, pdp);
    const swc = (c) => esc((window.NELVO_SW || {})[c] || '#ccc');
    const CHEV = '<svg class="dd__chev" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 9l6 6 6-6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    const OK = '<svg class="dd__ok" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    const szHtml = (z) => { const [a, b] = String(z ?? '').split(' · '); return `<span class="dd__name dd__sz"><b>${esc(a)}</b>${b ? `<small>${esc(b)}</small>` : ''}</span>`; }; // "Dubbel · 230 × 230 cm" → nome + misure sotto
    const avail = (c) => (hasSize ? P.variants.some((v) => v.c === c && v.a) : !!findV(c)?.a);
    const renderUnits = () => {
      $$('[data-units]', pdp).forEach((b) => { b.innerHTML = ''; b.hidden = true; });
      const box = unitsBox();
      if (!box || (!multiColor && !hasSize && !PZ)) return;
      box.hidden = false;
      box.innerHTML = units.slice(0, st.tier).map((u, i) => `
        <div class="unit" data-unit="${i}">
          <span class="unit__n">${esc(st.tier === 1 ? (multiColor && hasSize ? `${T('color')} · ${SZ}` : multiColor ? T('color') : hasSize ? SZ : PZT.title || '') : T('product_n', { n: i + 1 }))}</span>
          ${multiColor ? `<div class="dd" data-dd="${i}">
            <button type="button" class="dd__btn" data-dd-btn aria-haspopup="listbox" aria-expanded="false" aria-label="${esc(st.tier > 1 ? T('color_n', { n: i + 1 }) : T('color'))}: ${esc(u.c)}"><span class="dd__dot" style="background:${swc(u.c)}"></span><span class="dd__name">${esc(u.c)}</span>${CHEV}</button>
            <ul class="dd__list" role="listbox" data-dd-list hidden>${P.colors.map((c) => `<li role="option" tabindex="-1" class="dd__opt${c === u.c ? ' on' : ''}${avail(c) ? '' : ' is-out'}" data-uc-val="${esc(c)}" aria-selected="${c === u.c}"><span class="dd__dot" style="background:${swc(c)}"></span><span class="dd__name">${esc(c)}</span>${avail(c) ? '' : '<em>Slut</em>'}${OK}</li>`).join('')}</ul>
          </div>` : ''}${hasSize ? `
          <div class="dd dd--size" data-dd="${i}" data-dd-size>
            <button type="button" class="dd__btn" data-dd-btn aria-haspopup="listbox" aria-expanded="false" aria-label="${esc(st.tier > 1 ? T('size_n', { n: i + 1 }) : T('size'))}: ${esc(u.s)}">${szHtml(u.s)}${CHEV}</button>
            <ul class="dd__list" role="listbox" data-dd-list hidden>${P.sizes.map((z) => { const v = findV(u.c, z); return `<li role="option" tabindex="-1" class="dd__opt${z === u.s ? ' on' : ''}${v && v.a ? '' : ' is-out'}" data-us-val="${esc(z)}" aria-selected="${z === u.s}">${szHtml(z)}<span class="dd__p">${esc(money(v?.p ?? P.price))}</span>${OK}</li>`; }).join('')}</ul>
          </div>` : ''}${PZ ? `
          <div class="pz" data-pz="${i}">
            <label class="pz__f"><span class="pz__l">${esc(PZT.name)} <small>${esc(PZT.name_hint || '')}</small></span><input type="text" data-pz-name maxlength="${+PZN.max || 12}" autocomplete="off" autocapitalize="words" spellcheck="false" enterkeyhint="next" placeholder="${esc(PZT.name_ph || '')}" value="${esc(u.nm || '')}"></label>
            <label class="pz__f pz__f--n"><span class="pz__l">${esc(PZT.num)} <small>${esc(PZT.num_hint || '')}</small></span><input type="text" data-pz-num inputmode="numeric" pattern="[0-9]*" maxlength="2" autocomplete="off" enterkeyhint="done" placeholder="${esc(PZT.num_ph || '')}" value="${esc(u.no ?? '')}"></label>
            <p class="pz__err" data-pz-err role="alert" hidden></p>
          </div>` : ''}
        </div>`).join('');
    };
    const ddClose = (keep) => $$('[data-dd]', pdp).forEach((d) => { if (d === keep) return; d.classList.remove('open'); $('[data-dd-list]', d).hidden = true; $('[data-dd-btn]', d).setAttribute('aria-expanded', 'false'); });
    const ddOpen = (d) => { ddClose(d); const l = $('[data-dd-list]', d), o = l.hidden; l.hidden = !o; d.classList.toggle('open', o); $('[data-dd-btn]', d).setAttribute('aria-expanded', o); if (o) { ($('.dd__opt.on', l) || $('.dd__opt', l))?.focus({ preventScroll: true }); const r = l.getBoundingClientRect(); if (r.bottom > innerHeight - 8) scrollBy({ top: r.bottom - innerHeight + 24, behavior: 'smooth' }); } };
    const showColor = (c) => { // porta la galleria sul colore scelto senza toccare le altre unità
      if (galAll) { st.c = c; const i = slideIdx(c); if (i >= 0) track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); }
      else { st.c = c; gallery(); }
    };
    const pickSize = (i, z) => {
      const u = units[i]; if (!u) return;
      if (st.tier === 1) { u.s = z; setSize(z); }
      else { u.s = z; u.touchedS = true; renderUnits(); label(); }
      $(`[data-dd="${i}"][data-dd-size] [data-dd-btn]`, pdp)?.focus({ preventScroll: true });
    };
    // ?variant= senza perdere utm/ttclid/fbclid dell'annuncio
    const setVariantUrl = (id) => { const u = new URL(location.href); u.searchParams.set('variant', id); history.replaceState(null, '', u.pathname + u.search + u.hash); };
    const setSize = (z) => {
      st.s = z;
      units.forEach((u) => { if (!u.touchedS) u.s = z; });
      if (st.tier === 1 && units[0]) units[0].s = z;
      const v = findV(st.c, z); if (v) setVariantUrl(v.id);
      renderUnits(); label();
    };
    const pickUnit = (i, c) => {
      const u = units[i]; if (!u) return;
      if (st.tier === 1) { u.c = c; setColor(c); }
      else { u.c = c; u.touchedC = true; renderUnits(); showColor(c); }
      $(`[data-dd="${i}"] [data-dd-btn]`, pdp)?.focus({ preventScroll: true });
    };
    document.addEventListener('click', (e) => { if (!e.target.closest('[data-dd]')) ddClose(); });
    pdp.addEventListener('keydown', (e) => {
      const d = e.target.closest('[data-dd]'); if (!d) return;
      const l = $('[data-dd-list]', d);
      if (e.key === 'Escape') { ddClose(); $('[data-dd-btn]', d).focus(); return; }
      if (l.hidden) return;
      const os = $$('.dd__opt', l), k = os.indexOf(document.activeElement);
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); os[(k + (e.key === 'ArrowDown' ? 1 : -1) + os.length) % os.length].focus(); }
      if ((e.key === 'Enter' || e.key === ' ') && k >= 0) { e.preventDefault(); e.stopPropagation(); if (os[k].dataset.usVal != null) pickSize(+d.dataset.dd, os[k].dataset.usVal); else pickUnit(+d.dataset.dd, os[k].dataset.ucVal); }
    });
    const ensureUnits = () => { while (units.length < 3) units.push({ c: st.c, s: st.s }); };
    const ensureUnitsFor = (n) => { while (units.length < n) units.push({ c: st.c, s: st.s }); };
    const setTier = (n) => {
      st.tier = n;
      $$('[data-tier]', pdp).forEach((t) => { const on = +t.dataset.tier === n; t.classList.toggle('on', on); t.setAttribute('aria-checked', on); });
      renderUnits(); label();
    };
    const setColor = (c) => {
      st.c = c;
      $$('[data-color-val]', pdp).forEach((b) => b.classList.toggle('on', b.dataset.colorVal === c));
      const cl = $('[data-color-label]', pdp); if (cl) cl.textContent = c;
      units.forEach((u) => { if (!u.touchedC) u.c = c; });
      if (st.tier === 1 && units[0]) units[0].c = c;
      const v = findV(c); if (v && multiColor) setVariantUrl(v.id);
      gallery(); renderUnits(); if (hasSize) label();
    };

    pdp.addEventListener('click', (e) => {
      const ub = e.target.closest('[data-dd-btn]');
      if (ub) { ddOpen(ub.closest('[data-dd]')); return; }
      const us = e.target.closest('[data-us-val]');
      if (us) { pickSize(+us.closest('[data-dd]').dataset.dd, us.dataset.usVal); return; }
      const uo = e.target.closest('[data-uc-val]');
      if (uo) { pickUnit(+uo.closest('[data-dd]').dataset.dd, uo.dataset.ucVal); return; }
      const cb = e.target.closest('[data-color-val]');
      if (cb) { setColor(cb.dataset.colorVal); return; }
      const t = e.target.closest('[data-tier]');
      if (t && !e.target.closest('select,[data-units]') && +t.dataset.tier !== st.tier) { ddClose(); setTier(+t.dataset.tier); }
    });
    pdp.addEventListener('keydown', (e) => { const t = e.target.closest('[data-tier]'); if (t && (e.key === ' ' || e.key === 'Enter') && e.target === t) { e.preventDefault(); setTier(+t.dataset.tier); } });

    /* personalizzazione: valori salvati in units[i] a ogni tasto (renderUnits ridisegna i campi), errori per campo, Invio = campo successivo */
    const pzErr = (i) => {
      const u = units[i], box = $(`[data-pz="${i}"]`, pdp); if (!box) return null;
      const nm = (u.nm || '').trim(), no = String(u.no ?? ''), n = +no;
      const bad = { name: !nm || nm.length > (+PZN.max || 12), num: !/^\d{1,2}$/.test(no) || n < (+PZD.min || 0) || n > (+PZD.max || 99) };
      return bad;
    };
    const pzShow = (i, bad, only) => {
      const box = $(`[data-pz="${i}"]`, pdp); if (!box) return;
      const a = $('[data-pz-name]', box), b = $('[data-pz-num]', box), e = $('[data-pz-err]', box);
      if (!only || only === 'name') { a.classList.toggle('is-err', bad.name); a.setAttribute('aria-invalid', bad.name); }
      if (!only || only === 'num') { b.classList.toggle('is-err', bad.num); b.setAttribute('aria-invalid', bad.num); }
      const nb = a.classList.contains('is-err'), mb = b.classList.contains('is-err');
      e.textContent = nb && mb ? PZT.err || '' : nb ? PZT.err_name || '' : mb ? PZT.err_num || '' : ''; e.hidden = !e.textContent;
    };
    pdp.addEventListener('input', (e) => {
      const inp = e.target.closest('[data-pz-name],[data-pz-num]'); if (!inp) return;
      const i = +inp.closest('[data-pz]').dataset.pz, u = units[i]; if (!u) return;
      if (inp.hasAttribute('data-pz-num')) { const v = inp.value.replace(/\D/g, '').slice(0, 2); if (v !== inp.value) inp.value = v; u.no = v; } else u.nm = inp.value;
      if (inp.classList.contains('is-err')) pzShow(i, pzErr(i), inp.hasAttribute('data-pz-num') ? 'num' : 'name'); /* l'errore sparisce appena il campo è giusto */
    });
    pdp.addEventListener('keydown', (e) => {
      if (e.key !== 'Enter' || !e.target.closest('[data-pz-name],[data-pz-num]')) return;
      const all = $$('[data-pz-name],[data-pz-num]', pdp), k = all.indexOf(e.target), next = all.slice(k + 1).find((x) => !x.value.trim());
      if (next) { e.preventDefault(); next.focus(); }
    });
    const pzOk = () => {
      if (!PZ) return true;
      let first = null;
      for (let i = 0; i < st.tier; i++) {
        const bad = pzErr(i); if (!bad) continue; pzShow(i, bad);
        if (!first && (bad.name || bad.num)) first = $(`[data-pz="${i}"] ${bad.name ? '[data-pz-name]' : '[data-pz-num]'}`, pdp);
      }
      if (!first) return true;
      toast(PZT.err || '');
      first.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
      setTimeout(() => first.focus({ preventScroll: true }), reduced ? 0 : 450);
      return false;
    };
    const collect = () => {
      if (!pzOk()) return null;
      if (PZ) { /* una riga di carrello per pezzo, con le proprietà (etichette nella lingua del sito) */
        const out = [];
        for (let i = 0; i < st.tier; i++) {
          const v = findV(multiColor ? units[i].c : st.c, hasSize ? units[i].s : undefined);
          if (!v || !v.a) { toast(T('color_out')); return null; }
          out.push({ id: v.id, quantity: 1, properties: { [PZT.name || 'Name']: units[i].nm.trim(), [PZT.num || 'No']: String(units[i].no) } });
        }
        return out;
      }
      const map = new Map();
      for (let i = 0; i < st.tier; i++) {
        const v = findV(multiColor ? units[i].c : st.c, hasSize ? units[i].s : undefined);
        if (!v || !v.a) { toast(T('color_out')); return null; }
        map.set(v.id, (map.get(v.id) || 0) + 1);
      }
      return [...map].map(([id, quantity]) => ({ id, quantity }));
    };
    const atc = $('[data-atc]', pdp);
    $('[data-pdp-form]', pdp).addEventListener('submit', (e) => { e.preventDefault(); const items = collect(); if (items) Cart.add(items, atc); });
    const sticky = $('[data-sticky]', pdp), sBtn = $('[data-sticky-btn]', pdp);
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => sticky.classList.toggle('on', !en.isIntersecting && en.boundingClientRect.top < 0), { threshold: 0 }).observe(atc);
    }
    /* 17-ott: la barra fissa NON aggiunge più al carrello (tocchi involontari scorrendo col pollice → carrello aperto e chiuso subito):
       riporta su a pacchetti/colore, dove il cliente sceglie e preme «Aggiungi al carrello» */
    /* 17-ott (2): i replay mostravano salti continui ai pacchetti = tocchi involontari sulla barra mentre si scorre → tocco ignorato se la pagina
       si è mossa negli ultimi 600 ms (tocco voluto, a pagina ferma, funziona) */
    let lastScroll = 0; addEventListener('scroll', () => { lastScroll = Date.now(); }, { passive: true });
    sBtn?.addEventListener('click', () => { if (Date.now() - lastScroll < 600) return; const bx = $('[data-bundle]', pdp) || atc; window.scrollTo({ top: bx.getBoundingClientRect().top + window.scrollY - 84, behavior: 'smooth' }); });

    ensureUnits(); gallery(); setTier(1); setColor(st.c);
  }

  /* ---------------- product cards ---------------- */
  document.addEventListener('click', (e) => {
    const dot = e.target.closest('.sw-dot');
    if (dot) {
      e.preventDefault();
      const card = dot.closest('[data-card]');
      $$('.sw-dot', card).forEach((x) => x.classList.toggle('on', x === dot));
      const im = $('img.main', card);
      if (im && dot.dataset.img) { im.removeAttribute('srcset'); im.src = dot.dataset.img; }
      $$('[data-card-link]', card).forEach((a) => { const u = new URL(a.href); u.searchParams.set('variant', dot.dataset.vid); a.href = u.toString(); });
      return;
    }
    const q = e.target.closest('[data-quick]');
    if (q) {
      e.preventDefault();
      const card = q.closest('[data-card]');
      const data = JSON.parse($('[data-card-json]', card).textContent);
      const want = $('.sw-dot.on', card)?.dataset.sw;
      const v = data.variants.find((x) => x.a && (!want || x.c === want)) || data.variants.find((x) => x.a);
      if (v) Cart.add([{ id: v.id, quantity: 1 }], q);
    }
  });

  /* ---------------- sort ---------------- */
  $('[data-sort]')?.addEventListener('change', (e) => { const u = new URL(location.href); u.searchParams.set('sort_by', e.target.value); u.searchParams.delete('page'); location.href = u.toString(); });

  /* ---------------- loading buttons on forms ---------------- */
  $$('[data-loading-btn]').forEach((b) => b.closest('form')?.addEventListener('submit', () => b.classList.add('is-loading')));

  /* ---------------- recommendations ---------------- */
  const recos = $('[data-recos]');
  if (recos && !recos.children.length) {
    fetch(recos.dataset.url).then((r) => r.text()).then((html) => {
      const tmp = document.createElement('div'); tmp.innerHTML = html;
      const inner = $('[data-recos]', tmp); if (inner && inner.innerHTML.trim()) { recos.innerHTML = inner.innerHTML; initSliders(recos); } else recos.remove();
    }).catch(() => recos.remove());
  }

  /* ---------------- reveal ---------------- */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((ens) => ens.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } }), { rootMargin: '0px 0px -8% 0px' });
    $$('.rv').forEach((el, i) => { el.style.transitionDelay = `${(i % 4) * 60}ms`; io.observe(el); });
  } else $$('.rv').forEach((el) => el.classList.add('in'));
})();
